'use strict';
angular.module('theme').directive('repeatField', function () {
	return {
		require: 'ngModel',
		scope: {
			originalValue: '=repeatField'
		},
		link: function(scope, element, attributes, ngModel) {

			ngModel.$validators.repeatField = function (modelValue) {
				return modelValue === scope.originalValue;
			};

			scope.$watch('originalValue', function() {
				ngModel.$validate();
			});
		}
	};
});
